/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import ReturnOrderList from "./ReturnOrderTable";
import ReturnOrderDetails from "./ReturnOrderDetails";
import {
  getAllReturnOrderRequest,
  getSingleReturnOrderRequestDetails,
} from "../../reducers/adminReducers";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Loader from "../loader/loader";

const ReturnOrder = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const result = useSelector((state) => state.admin);
  const { retunrOrderRequestData, singleReturnOrderData } = result || {};
  const [loader, setLoader] = useState(false);
  const [actionId, setActionId] = useState(null);

  useEffect(() => {
    setLoader(true);
    dispatch(getAllReturnOrderRequest()).then(() => {
      setLoader(false);
    });
  }, []);

  const getSingleOrderDetails = (id) => {
    setActionId(id);
    dispatch(getSingleReturnOrderRequestDetails(id)).then(() => {
      setIsOpen(true);
    });
  };
  return (
    <Fragment>
      <Breadcrumb title="Return order" parent="orders" />
      <Container fluid={true}>
        <div className="admin-card">
          {loader ? (
            <Loader />
          ) : (
            <Card>
              <CardHeader>
                <h5>Return Order</h5>
              </CardHeader>
              <CardBody>
                <ReturnOrderList
                  retunrOrderRequestData={retunrOrderRequestData}
                  onShowDetails={(row) => getSingleOrderDetails(row?._id)}
                />
              </CardBody>
            </Card>
          )}
        </div>
      </Container>
      <ReturnOrderDetails
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        singleReturnOrderData={singleReturnOrderData}
        id={actionId}
        setId={setActionId}
      />
    </Fragment>
  );
};

export default ReturnOrder;
